
// 3rd Party Components
import React, { Component } from 'react';

// Styles
import './styles/Navbar.css';

// Views
import ContentView from './ContentView';
import Dropdown from './util/Dropdown';
import TabBar from './util/TabBar';

// Custum Components
import { locationIsMinistry, listenTo } from './util/Utility';

export default class Navbar extends Component {

  updateMinistry(updatedMinistry) {
    var ministries = this.state.ministries;
    ministries.forEach(function(ministry, i) {
      if (updatedMinistry.key === ministry.key) {
        ministries[i] = updatedMinistry;
      }
    });
    this.setState({ministries: ministries});
  }

  constructor(props) {
    super(props);
    this.state = {
      ministries: null,
      permissions: null,
      encouragement: null
    };

    // Listen for changes to the current location.
    this.unlisten = window.historyObj.listen((location, action) => { // eslint-disable-line no-unused-vars
      //if (locationIsMinistry(location.pathname) && getTab(location.pathname) === "n/a") window.historyObj.push(location.pathname + "/announcements");
      if (location.pathname !== "/profile") this.forceUpdate();
    });
  }

  componentWillMount() {
    listenTo("ministries", this, ministries => this.setState({ministries}, () => console.warn("GOT NEW MINISTRIES")));
    listenTo("permissions/" + this.props.user.uid, this, permissions => {
      this.setState({permissions});
    }, null, null, false);
    listenTo("encouragement", this, encouragement => {
      window.encouragement = encouragement;
      this.setState({encouragement});
    }, {
      orderByChild: 'leaderID',
      equalTo: this.props.user.uid
    })
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {

    const location = window.historyObj.location.pathname;

    var ministryID = null;
    if (locationIsMinistry(location)) {
      ministryID = location.split("/")[1];
    }

    var ministry = (location && ministryID !== null && this.state.ministries !== null) ? this.state.ministries.filter(ministry => { return ministry.key === ministryID })[0] : null;

    var pages = [];

    //pages.push({label: "Events List", to: "/week", type: 0});
    //pages.push({label: "Calendar", to: "/calendar", type: 0});

    let item = this.state.permissions;
    if (item) {
      //if (item.approval1) {
      //  pages.push({label: "Availability Approvals", to: "/approval1", type: 1});
      //}
      if (item.approval2) {
        pages.push({label: "Validity Approvals", to: "/approval2", type: 1});
      }
      if (item.approval3) {
        pages.push({label: "Resources", to: "/resources", type: 0});
        //pages.push({label: "Technical Approvals", to: "/approval3", type: 1});
      }
      //if (item.approval4) {
      //  pages.push({label: "Final Approvals", to: "/approval4", type: 1});
      //}
      if (item.sermons) {
        pages.push({label: "Sermons", to: "/sermons", type: 1});
      }
      if (item.userApproval) {
        pages.push({label: "User Approval", to: "/user_approval", type: 1});
      }
      if (item.permissions) {
        pages.push({label: "Edit Permissions", to: "/permissions", type: 1});
      }
      if (item.editMinistries) {
        pages.push({label: "Manage Ministries", to: "/ministries", type: 1});
      }
      if (item.bugs) {
        pages.push({label: "Bugs & Feature Requests", to: "/bugs", type: 1});
      }
      //if (item.financial) {
      //  pages.push({label: "Event Payments", to: "/payments", type: 1});
      //}

      if (item.ministries && this.state.ministries) {
        this.state.ministries.forEach(ministry => {
          Object.keys(item.ministries).forEach(ministryNumber => {
            if (ministry.key == ministryNumber) {
              pages.push({label: ministry.name, to: "/" + ministry.key, type: 2});
            }
          });
        });
      }

      // Hiding until encouragement support is enabled
      /*
      var encouragement = {label: "Encouragement", to:  "/encouragement", type: 3};

      if (this.state.encouragement && this.state.encouragement.filter(item => !item.seen).length > 0) {
        encouragement.label = "Encouragement (" + this.state.encouragement.filter(item => !item.seen).length.toString() + " new)";
      }

      pages.push(encouragement);
      */
    }

    pages.push({label: "Profile & Account", to:  "/account", type: 3});

    // With TabBar
    //return (
    //  <div>
    //    <div className="Navbar">
    //      <Dropdown options={pages} placeholder="Select..." location={location} />
    //      <TabBar ministry={ministry} {...this.props} location={location} />
    //    </div>
    //    <ContentView permissions={this.state.permissions} location={location} {...this.props} updateMinistry={this.updateMinistry.bind(this)} pages={this.state.permissions ? pages : null} ministry={ministry} />
    //  </div>
    //);

    // Without TabBar
    return (
      <div>
        <div className="Navbar">
          <Dropdown options={pages} placeholder="Select..." location={location} />
        </div>
        <ContentView permissions={this.state.permissions} location={location} {...this.props} updateMinistry={this.updateMinistry.bind(this)} pages={this.state.permissions ? pages : null} ministry={ministry} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Navbar.js
 **/